const getStatusColor = (status: string): "yellow" | "red" | "blue" | "green" | undefined => {
  switch (status) {
    case 'ACTIVE':
      return 'yellow';
    case 'SELECTED':
      return 'blue';
    case 'CANCELLED':
      return 'red';
    case 'CONFIRMED':
      return 'green';
  }
}

// New function to map API status to user-friendly display status
export const getDisplayStatus = (apiStatus: string): string => {
  switch (apiStatus) {
    case 'ACTIVE':
      return 'Open';
    case 'CONFIRMED':
      return 'Confirmed';
    case 'SELECTED':
      return 'Selected';
    case 'ACCEPTED':
      // Application-level status should display as Selected in UI
      return 'Selected';
    case 'CANCELLED':
      return 'Cancelled';
    case 'COMPLETED':
      return 'Worked';
    case 'EXPIRED':
      return 'Expired';
    case 'NO_SHOW':
      return 'No Show';
    case 'MISSED_CLOCK_IN':
    case 'MISSED_CLOCK_OUT':
      return 'Unresolved';
    case 'CLOCKED_IN':
      return 'In Progress';
    default:
      return apiStatus;
  }
}

// Function to determine if there are applicants (for "Applicants Applied" status)
// Excludes withdrawn and rejected applications
export const hasApplicants = (applications: Array<{ status?: string }>): boolean => {
  if (!applications || applications.length === 0) {
    return false;
  }
  
  // Filter out withdrawn and rejected applications and check if any remain
  const activeApplications = applications.filter(app => 
    app.status && app.status !== 'WITHDRAWN' && app.status !== 'REJECTED'
  );
  
  return activeApplications.length > 0;
}

export default getStatusColor